import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useIntl, useDispatch, useFeatureToggles, useSelector } from "@grandvisionhq/state";
import { useSetShippingMethod } from "../../../../../../hooks/operations/hooks/operations/use-set-shipping-method.js";
import { useSetShippingMethodState } from "../../../../../../hooks/operations/hooks/operations/use-set-shipping-method-state.js";
import { selectShippingMethod } from "../../../../../StepShipping/actions.js";
import { useShippingMethodsList } from "../../../../../modules/ShippingMethods/hooks/StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js";
import { getSelectedShippingMethod } from "../../../../../StepShipping/selectors.js";
import { AlternativeShippingMethodsList } from "./AlternativeShippingMethodsList.js";
const AlternativeShippingMethodsListContainer = ({
  onNextStep,
  closeAlternateShippingModal
}) => {
  const { getLabel, country } = useIntl();
  const dispatch = useDispatch();
  const { cart } = Context.useCart();
  const { allowAlternativeShippingState } = useFeatureToggles();
  const { setShippingMethodState } = useSetShippingMethodState();
  const resetShippingMethodsState = React.useCallback(() => {
    if (cart?.hasAlternativeShippingState) {
      setShippingMethodState(country);
    }
  }, [cart?.hasAlternativeShippingState, country]);
  const handleCloseAlternateShippingModal = React.useCallback(() => {
    closeAlternateShippingModal();
    resetShippingMethodsState();
  }, [resetShippingMethodsState, closeAlternateShippingModal]);
  const selectedShippingMethod = useSelector(getSelectedShippingMethod);
  const { reloadShippingMethods } = useShippingMethodsList();
  const handleOnCompleted = React.useCallback(
    (_, selectedAlternativeShippingMethod) => {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: selectedAlternativeShippingMethod,
            isValid: true,
            isTouched: true
          }
        })
      );
    },
    [dispatch]
  );
  const { setShippingMethod } = useSetShippingMethod({
    onError: () => reloadShippingMethods(),
    onCompleted: handleOnCompleted
  });
  const labels = {
    description: getLabel("cart.shippingMethod.modal.description"),
    buttonCaptionLabel: getLabel("common.actions.continue"),
    free: getLabel("common.free"),
    back: getLabel("cart.actions.goBack"),
    errorTitle: getLabel("cart.shippingMethod.error.title"),
    errorDescription: getLabel("cart.shippingMethod.error.description"),
    alternativeShippingMethodTitle: getLabel("checkout.shipment.method.alternative.modal.title")
  };
  const handleChange = React.useCallback(
    async (selectedAlternativeShippingMethod) => {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: selectedAlternativeShippingMethod?.value,
            isValid: true,
            isTouched: true
          }
        })
      );
      selectedAlternativeShippingMethod && await setShippingMethod(selectedAlternativeShippingMethod?.id);
    },
    [dispatch, setShippingMethod]
  );
  const handleSubmit = React.useCallback(() => {
    onNextStep();
  }, [onNextStep]);
  if (!allowAlternativeShippingState) return null;
  return /* @__PURE__ */ React.createElement(
    AlternativeShippingMethodsList,
    {
      onModalClose: handleCloseAlternateShippingModal,
      labels,
      selectedShippingMethod,
      onSubmit: handleSubmit,
      onChange: handleChange
    }
  );
};
export {
  AlternativeShippingMethodsListContainer
};
//# sourceMappingURL=AlternativeShippingMethodsListContainer.js.map
